var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicUploadSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 23.2794V27.3328C4 27.7061 4.29333 27.9994 4.66667 27.9994H8.72C8.89333 27.9994 9.06667 27.9328 9.18667 27.7994L23.7467 13.2528L18.7467 8.25276L4.2 22.7994C4.06667 22.9328 4 23.0928 4 23.2794ZM27.6133 9.38609C28.1333 8.86609 28.1333 8.02609 27.6133 7.50609L24.4933 4.38609C23.9733 3.86609 23.1333 3.86609 22.6133 4.38609L20.1733 6.82609L25.1733 11.8261L27.6133 9.38609Z",
    fill: "#282860"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicUploadSvg);
export default __webpack_public_path__ + "static/media/profilePicUploadSvg.8020e6ba071cc89ecf0a74fdfd06e6e4.svg";
export { ForwardRef as ReactComponent };